// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Просмотрщик изображений (аватар, фото заявки, портфолио провайдера) */

.image-lightbox-overlay {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.72);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  animation: image-lightbox-fade 0.18s ease;
}

@keyframes image-lightbox-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

.image-lightbox {
  display: flex;
  flex-direction: column;
  width: min(1100px, 100%);
  max-height: 100%;
  overflow: hidden;
  background: var(--bg-secondary, #fff);
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));
  border-radius: 14px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
  animation: image-lightbox-pop 0.18s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes image-lightbox-pop {
  from { opacity: 0; transform: scale(0.97); }
  to { opacity: 1; transform: scale(1); }
}

.image-lightbox-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  flex-shrink: 0;
}

.image-lightbox-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: var(--text-secondary);
  font-size: 0.85rem;
  font-weight: 500;
}

.image-lightbox-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-lightbox-tools {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.image-lightbox-counter {
  font-family: 'Fira Code', 'Fira Sans', monospace;
  font-size: 0.8rem;
  font-variant-numeric: tabular-nums;
  color: var(--text-secondary);
  margin-right: 4px;
}

.image-lightbox-zoom-value {
  font-family: 'Fira Code', 'Fira Sans', monospace;
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
  color: var(--text-secondary);
  min-width: 42px;
  text-align: center;
}

.image-lightbox-tool {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.image-lightbox-tool:hover:not(:disabled) {
  background: var(--nav-hover-bg, rgba(0, 0, 0, 0.05));
  color: var(--text-primary);
}

.image-lightbox-tool:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.image-lightbox-close:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
}

.image-lightbox-body {
  position: relative;
  flex: 1 1;
  min-height: 0;
  display: flex;
}

.image-lightbox-stage {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow: auto;
  background:
    repeating-conic-gradient(rgba(148, 163, 184, 0.12) 0% 25%, transparent 0% 50%) 50% / 22px 22px;
}

.image-lightbox-stage.zoomed {
  align-items: flex-start;
  justify-content: flex-start;
  cursor: grab;
}

.image-lightbox-image {
  display: block;
  margin: auto;
  max-width: 100%;
  max-height: calc(100vh - 260px);
  object-fit: contain;
  border-radius: 6px;
  -webkit-user-select: none;
          user-select: none;
}

/* При зуме картинка не сжимается флексом, а выходит за края — чтобы стейдж скроллился */
.image-lightbox-stage.zoomed .image-lightbox-image {
  flex-shrink: 0;
  margin: 0;
}

.image-lightbox-broken {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 48px 16px;
  color: var(--text-secondary);
  font-size: 0.875rem;
}

.image-lightbox-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  padding: 0;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));
  border-radius: 50%;
  background: var(--bg-secondary, #fff);
  color: var(--text-primary);
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  transition: all 0.2s ease;
  z-index: 2;
}

.image-lightbox-nav:hover {
  background: var(--accent-primary, #3b82f6);
  border-color: var(--accent-primary, #3b82f6);
  color: #fff;
  transform: translateY(-50%) scale(1.06);
}

.image-lightbox-nav.prev { left: 12px; }
.image-lightbox-nav.next { right: 12px; }

.image-lightbox-thumbs {
  display: flex;
  gap: 8px;
  padding: 10px 14px;
  overflow-x: auto;
  overflow-y: hidden;
  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  flex-shrink: 0;
  scrollbar-width: thin;
}

.image-lightbox-thumb {
  width: 62px;
  height: 62px;
  flex: 0 0 auto;
  padding: 0;
  overflow: hidden;
  border: 2px solid transparent;
  border-radius: 8px;
  background: var(--bg-primary, #f8fafc);
  cursor: pointer;
  opacity: 0.6;
  transition: all 0.2s ease;
}

.image-lightbox-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-lightbox-thumb:hover { opacity: 0.9; }

.image-lightbox-thumb.active {
  opacity: 1;
  border-color: var(--accent-primary, #3b82f6);
}

[data-theme='dark'] .image-lightbox-overlay {
  background: rgba(2, 6, 23, 0.8);
}

[data-theme='dark'] .image-lightbox {
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);
}

@media (max-width: 768px) {
  .image-lightbox-overlay { padding: 12px; }
  .image-lightbox-image { max-height: calc(100vh - 220px); }
  .image-lightbox-thumb { width: 50px; height: 50px; }
  .image-lightbox-zoom-value { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/css/image-lightbox.css"],"names":[],"mappings":"AAAA,wEAAwE;;AAExE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,yDAAyD;EACzD,mBAAmB;EACnB,2CAA2C;EAC3C,gEAAgE;AAClE;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iEAAiE;EACjE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,iBAAiB;EACjB,kCAAkC;EAClC,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd;kGACgG;AAClG;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,wFAAwF;AACxF;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,yDAAyD;EACzD,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,WAAW;EACX,uCAAuC;AACzC;;AAEA,2BAA2B,UAAU,EAAE;AACvC,2BAA2B,WAAW,EAAE;;AAExC;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,8DAA8D;EAC9D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8BAA8B,YAAY,EAAE;;AAE5C;EACE,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B,aAAa,EAAE;EACzC,wBAAwB,+BAA+B,EAAE;EACzD,wBAAwB,WAAW,EAAE,YAAY,EAAE;EACnD,6BAA6B,aAAa,EAAE;AAC9C","sourcesContent":["/* Просмотрщик изображений (аватар, фото заявки, портфолио провайдера) */\n\n.image-lightbox-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 4000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.72);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  animation: image-lightbox-fade 0.18s ease;\n}\n\n@keyframes image-lightbox-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.image-lightbox {\n  display: flex;\n  flex-direction: column;\n  width: min(1100px, 100%);\n  max-height: 100%;\n  overflow: hidden;\n  background: var(--bg-secondary, #fff);\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));\n  border-radius: 14px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);\n  animation: image-lightbox-pop 0.18s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes image-lightbox-pop {\n  from { opacity: 0; transform: scale(0.97); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.image-lightbox-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  flex-shrink: 0;\n}\n\n.image-lightbox-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.image-lightbox-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.image-lightbox-tools {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.image-lightbox-counter {\n  font-family: 'Fira Code', 'Fira Sans', monospace;\n  font-size: 0.8rem;\n  font-variant-numeric: tabular-nums;\n  color: var(--text-secondary);\n  margin-right: 4px;\n}\n\n.image-lightbox-zoom-value {\n  font-family: 'Fira Code', 'Fira Sans', monospace;\n  font-size: 0.75rem;\n  font-variant-numeric: tabular-nums;\n  color: var(--text-secondary);\n  min-width: 42px;\n  text-align: center;\n}\n\n.image-lightbox-tool {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.image-lightbox-tool:hover:not(:disabled) {\n  background: var(--nav-hover-bg, rgba(0, 0, 0, 0.05));\n  color: var(--text-primary);\n}\n\n.image-lightbox-tool:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.image-lightbox-close:hover:not(:disabled) {\n  background: rgba(239, 68, 68, 0.12);\n  color: #ef4444;\n}\n\n.image-lightbox-body {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n}\n\n.image-lightbox-stage {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  overflow: auto;\n  background:\n    repeating-conic-gradient(rgba(148, 163, 184, 0.12) 0% 25%, transparent 0% 50%) 50% / 22px 22px;\n}\n\n.image-lightbox-stage.zoomed {\n  align-items: flex-start;\n  justify-content: flex-start;\n  cursor: grab;\n}\n\n.image-lightbox-image {\n  display: block;\n  margin: auto;\n  max-width: 100%;\n  max-height: calc(100vh - 260px);\n  object-fit: contain;\n  border-radius: 6px;\n  user-select: none;\n}\n\n/* При зуме картинка не сжимается флексом, а выходит за края — чтобы стейдж скроллился */\n.image-lightbox-stage.zoomed .image-lightbox-image {\n  flex-shrink: 0;\n  margin: 0;\n}\n\n.image-lightbox-broken {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 48px 16px;\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n}\n\n.image-lightbox-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  flex-shrink: 0;\n  padding: 0;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));\n  border-radius: 50%;\n  background: var(--bg-secondary, #fff);\n  color: var(--text-primary);\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);\n  transition: all 0.2s ease;\n  z-index: 2;\n}\n\n.image-lightbox-nav:hover {\n  background: var(--accent-primary, #3b82f6);\n  border-color: var(--accent-primary, #3b82f6);\n  color: #fff;\n  transform: translateY(-50%) scale(1.06);\n}\n\n.image-lightbox-nav.prev { left: 12px; }\n.image-lightbox-nav.next { right: 12px; }\n\n.image-lightbox-thumbs {\n  display: flex;\n  gap: 8px;\n  padding: 10px 14px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  flex-shrink: 0;\n  scrollbar-width: thin;\n}\n\n.image-lightbox-thumb {\n  width: 62px;\n  height: 62px;\n  flex: 0 0 auto;\n  padding: 0;\n  overflow: hidden;\n  border: 2px solid transparent;\n  border-radius: 8px;\n  background: var(--bg-primary, #f8fafc);\n  cursor: pointer;\n  opacity: 0.6;\n  transition: all 0.2s ease;\n}\n\n.image-lightbox-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.image-lightbox-thumb:hover { opacity: 0.9; }\n\n.image-lightbox-thumb.active {\n  opacity: 1;\n  border-color: var(--accent-primary, #3b82f6);\n}\n\n[data-theme='dark'] .image-lightbox-overlay {\n  background: rgba(2, 6, 23, 0.8);\n}\n\n[data-theme='dark'] .image-lightbox {\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);\n}\n\n@media (max-width: 768px) {\n  .image-lightbox-overlay { padding: 12px; }\n  .image-lightbox-image { max-height: calc(100vh - 220px); }\n  .image-lightbox-thumb { width: 50px; height: 50px; }\n  .image-lightbox-zoom-value { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
